// usePreselectSite.ts
import { useEffect } from "react";
import { SiteChangeSource } from "../types/SiteChangeTypes";
import { IApplicationState } from '../store';
import { useSelector } from "react-redux";
import useSiteChange from "./useSiteChange";

export function usePreselectSite() {
    const { changeSite } = useSiteChange();

    const sites = useSelector((state: IApplicationState) => state.sites.sites);
    const preSelectedSite = useSelector((state: IApplicationState) => state.sites.preselectedSite);
    const selectedSite = useSelector((state: IApplicationState) => state.sites.selectedSite);

    useEffect(() => {
        if (!selectedSite && preSelectedSite && sites?.length) {
            const preselectedSiteId = parseInt(preSelectedSite);
            const target = sites.find(
                x => x.urlKey === preSelectedSite || x.siteId === preselectedSiteId
            );
            if (target) {
                changeSite(target, {
                    source: SiteChangeSource.Preselected,
                    skipCodeClearing: true,
                });
            }
        }
    }, [preSelectedSite, sites, selectedSite, changeSite]);
}

